import React from "react";
import { Link } from "react-router-dom";

// reactstrap components
import {
  Button,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";

export default function SimpleFooter(props) {

    return (
        <footer className=" footer">
            <Container>
                <Row className="row-grid mb-5 mt-5">
                    <Col lg="6">
                        <h4 className="display-4">What is Club Apps?</h4>
                        <p className="lead">
                            We are the standard in Club and Organization Software offering a feature rich application for administrators and a fast, intuitive front end for members and guests.
                        </p>
                    </Col>
                    <Col lg="6">
                        <div className="nav-container mr-5">
                            <h3 className="heading">DISCOVER</h3>
                            <Nav className="nav-pre-footer">
                                <NavItem>
                                    <NavLink
                                        to="/overview"
                                        tag={Link}
                                        >
                                        Overview
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        to="/features"
                                        tag={Link}
                                        >
                                        Features
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        to="/pricing"
                                        tag={Link}
                                        >
                                        Pricing
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </div>
                        <div className="nav-container  mr-5">
                            <h3 className="heading">COMPANY</h3>
                            <Nav className="nav-pre-footer">
                                <NavItem>
                                    <NavLink
                                        to="/about-us"
                                        tag={Link}
                                        >
                                        About Us
                                    </NavLink>
                                </NavItem>
                                {/*}
                                <NavItem>
                                    <NavLink
                                        to="/our-team"
                                        tag={Link}
                                        >
                                        Our Team
                                    </NavLink>
                                </NavItem>
                                */}
                                <NavItem>
                                    <NavLink
                                        to="/jobs"
                                        tag={Link}
                                        >
                                        Jobs
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        to="/contact"
                                        tag={Link}
                                        >
                                        Contact Us
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </div>
                        <div className="nav-container">
                            <h3 className="heading">QUICK LINKS</h3>
                            <Nav className="nav-pre-footer">
                                <NavItem>
                                    <NavLink
                                        href="https://clubapps.org/login"
                                        title="Login to Club Apps"
                                        >
                                        Login
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        href="https://clubapps.org/register"
                                        title="Register for Club Apps"
                                        >
                                        Register
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </div>
                    </Col>
                </Row>
                <hr />
                <Row className="align-items-center justify-content-md-between">
                    <Col md="6">
                        <div className="copyright text-center text-md-left">
                            © {new Date().getFullYear()} Club Apps, LLC. All rights reserved.
                        </div>
                  </Col>
                  <Col md="6">
                      <Nav className="nav-footer justify-content-center justify-content-md-end">
                          <NavItem>
                              <NavLink
                                  href="https://support.clubapps.org/"
                                  target="_blank"
                                  title="Visit our Support Center"
                                  >
                                  Support
                              </NavLink>
                          </NavItem>
                          <NavItem>
                              <NavLink
                                  href="https://clubapps.app/legal"
                                  target="_blank"
                                  title="Visit our Legal Center"
                                  >
                                  Privacy & Terms
                              </NavLink>
                          </NavItem>
                      </Nav>
                  </Col>
              </Row>
          </Container>
        </footer>
    );
}
